/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MergedCardTransactionDetailEvidenceListInnerErrors
 */
export interface MergedCardTransactionDetailEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'detectedDpi'?: MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'calculatedDpi'?: MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'colorGradation'?: MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'heightMillis'?: MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof MergedCardTransactionDetailEvidenceListInnerErrors
     */
    'widthMillis'?: MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum;
}

export const MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsDetectedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsCalculatedDpiEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsColorGradationEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsHeightMillisEnum];
export const MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum = typeof MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum[keyof typeof MergedCardTransactionDetailEvidenceListInnerErrorsWidthMillisEnum];


